<template>
    <tab-bar
        :tabs="tabs"
    />
</template>

<script>
import TabBar from '../../components/tab-bar.vue';

export default {
    components: {
        TabBar,
    },

    props: {
        current_tab: { default: 'documents' },
        documents_index_route: {},
        signatures_index_route: {},
    },

    data() {
        return {
            tabs: [
                {
                    value: 'documents',
                    label: 'Document Library',
                    current: this.current_tab === 'documents',
                    icon: 'fa fa-list-alt',
                    href: this.documents_index_route,
                },
                {
                    value: 'signatures',
                    label: 'Signatures',
                    current: this.current_tab === 'signatures',
                    icon: 'fa fa-pen-nib',
                    href: this.signatures_index_route,
                },
            ],
        }
    },
}
</script>
